import {
  BaseYuzuLoggerServiceFabricParams,
  getYuzuFabric,
  WindowWithYuzu,
  YuzuLog,
  YuzuLogRequestBody,
} from '@xometry/ui';
import { CURRENT_REGION } from 'common/config/regions/config';
import { ENV } from 'common/constants/env';

import { YuzuEvents } from './Yuzu.events';

const { ENV_CUSTOM_ENV, RELEASE, YUZU_BASE_URL } = ENV;

const baseParams: BaseYuzuLoggerServiceFabricParams<
  YuzuEvents,
  YuzuLog<YuzuEvents>,
  YuzuLogRequestBody<YuzuEvents, YuzuLog<YuzuEvents>>
> = {
  initialQueueGetter: () => {
    if (typeof window !== 'undefined') {
      return (window as WindowWithYuzu)?.__yuzu__?.queue || [];
    }

    return [];
  },
  baseMetaGetter: () => {
    return {
      app: 'pa',
      appVersion: RELEASE,
      region: CURRENT_REGION.toLowerCase(),
      env: ENV_CUSTOM_ENV,
    };
  },
  logContextGetter: ({ baseLogContextGetter }) => {
    return {
      ...baseLogContextGetter(),
      userId: '',
      activeExperiments: {},
    };
  },
  onLog:
    ENV_CUSTOM_ENV === 'production'
      ? undefined
      : (e) => {
          console.info(e);
        },
};

const sendFn = () => Promise.resolve({});
const params =
  ENV_CUSTOM_ENV === 'development' || ENV_CUSTOM_ENV === 'test' || ENV_CUSTOM_ENV === 'e2e'
    ? { ...baseParams, sendFn }
    : {
        ...baseParams,
        endpoint: `${YUZU_BASE_URL}/client`,
      };

export const getYuzu = getYuzuFabric<
  YuzuEvents,
  YuzuLog<YuzuEvents>,
  YuzuLogRequestBody<YuzuEvents, YuzuLog<YuzuEvents>>
>(params);
